module.exports = __webpack_public_path__ + "img/AFROCHAMPIONS.8d0487c5.svg";